/* eslint-disable max-lines-per-function */
import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import { Grid } from "@mui/material";
import NotFound from "pages/not-found";
import { authorizeForRole } from "components/auth/authorize-for-role";
import { UserRole } from "types/gql-types";
import Home from "./home";

import FeatureFlagsPage from "./feature-flags";
import Interests from "./interests";

import Lists from "./lists";
import ListsNew from "./lists/new";
import ListsUpdate from "./lists/update";

import Properties from "./properties";
import PropertiesNew from "./properties/new";
import PropertiesUpdate from "./properties/update";

import Organizations from "./organizations";
import OrganizationsNew from "./organizations/new";
import OrganizationsUpdate from "./organizations/update";
import Questions from "./forms-questions";
import Forms from "./forms";
import FormsNew from "./forms/new";
import FormsUpdate from "./forms/update";

import Users from "./users";
import Importers from "./import";

import SideBar from "./sidebar";
import BillingSearchPage from "./billing/billing-search";
import NewBillingPage from "./billing/billing-new";
import LettersSearchPage from "./billing/letters-search";
import DebugPage from "./debug";

import PricingIndex from "./pricing";
import PricingNew from "./pricing/new";
import PricingUpdate from "./pricing/update";

import SubscriptionsIndex from "./subscriptions";
import SubscriptionsNew from "./subscriptions/new";
import SubscriptionsUpdate from "./subscriptions/update";

import PlansIndex from "./plans";
import PlansNew from "./plans/new";
import PlansUpdate from "./plans/update";
import AdminContractsPage from "./contracts";
import NewManualContract from "./contracts/new";
import EditManualContract from "./contracts/edit";

// layout uses a scroll container w/ static sidebar so scrolling `body` won't work.
// Wrap the call: Element.scroll() returns a Promise, which useEffect must not return.

const AdminDashboard: React.FC = () => {
  useEffect(() => {
    document.getElementById("main")?.scroll(0, 0);
  }, []);

  return (
    <Grid container spacing={0}>
      <Grid size={{ sm: 3, md: 2 }} className="dash-sidebar">
        <SideBar />
      </Grid>
      <Grid id="main" size={{ sm: 9, md: 10 }} className="dash-main" container style={{ marginTop: "8px", marginBottom: "8px" }}>
        <Grid size={{ xs: 12 }}>
          <Routes>
            <Route index element={<Home />} />

            <Route path="importers/*" element={<Importers />} />

            <Route path="billing" element={<BillingSearchPage />} />
            <Route path="billing/:month" element={<BillingSearchPage />} />
            <Route path="billing/new" element={<NewBillingPage />} />
            <Route path="billing/new/:month" element={<NewBillingPage />} />
            <Route path="billing/letters/:type/:id/:month" element={<LettersSearchPage />} />
            <Route path="pricing" element={<PricingIndex />} />
            <Route path="pricing/new" element={<PricingNew />} />
            <Route path="pricing/:pricingId/edit" element={<PricingUpdate />} />
            <Route path="subscriptions" element={<SubscriptionsIndex />} />
            <Route path="subscriptions/new" element={<SubscriptionsNew />} />
            <Route path="subscriptions/:subscriptionId/edit" element={<SubscriptionsUpdate />} />
            <Route path="plans" element={<PlansIndex />} />
            <Route path="plans/new" element={<PlansNew />} />
            <Route path="plans/:planId/edit" element={<PlansUpdate />} />
            <Route path="feature-flags" element={<FeatureFlagsPage />} />
            <Route path="contracts" element={<AdminContractsPage />} />
            <Route path="contracts/new" element={<NewManualContract />} />
            <Route path="contracts/:contractId/edit" element={<EditManualContract />} />

            <Route path="interests" element={<Interests />} />
            <Route path="users/*" element={<Users />} />

            <Route path="organizations" element={<Organizations />} />
            <Route path="organizations/new" element={<OrganizationsNew />} />
            <Route path="organizations/:id" element={<OrganizationsUpdate />} />

            <Route path="lists" element={<Lists />} />
            <Route path="lists/new" element={<ListsNew />} />
            <Route path="lists/:id" element={<ListsUpdate />} />

            <Route path="properties" element={<Properties />} />
            <Route path="properties/new" element={<PropertiesNew />} />
            <Route path="properties/:id" element={<PropertiesUpdate />} />

            <Route path="form-questions" element={<Questions />} />
            <Route path="forms" element={<Forms />} />
            <Route path="forms/new" element={<FormsNew />} />
            <Route path="forms/:id" element={<FormsUpdate />} />

            <Route path="debug" element={<DebugPage />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default authorizeForRole([UserRole.ADMIN], AdminDashboard);
